import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api';
import { useIsAuthenticated } from '../model/session-store';
import type { SessionUser } from '../model/types';

export const sessionKeys = {
  all: ['session'] as const,
  profile: () => [...sessionKeys.all, 'profile'] as const,
};

export const getProfile = () => apiClient.get<SessionUser>('/auth/profile');

/** Current user's profile; only runs while signed in. */
export function useProfile() {
  const isAuthenticated = useIsAuthenticated();
  return useQuery({
    queryKey: sessionKeys.profile(),
    queryFn: getProfile,
    enabled: isAuthenticated,
  });
}
